function TargetTipsIcon() {
  return (
    <svg
      width="115"
      height="90"
      viewBox="0 0 115 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.9401 86.913C53.9991 80.1581 41.5382 58.0294 18.9865 43.9593C-1.13851 31.4025 39.4843 -6.63872 61.9401 1.00572C115.883 19.3711 124.864 32.3728 104.894 43.9593C84.3741 55.8643 80.0089 102.285 61.9401 86.913Z"
        fill="#FFEBCA"
      />
      <path
        d="M83.562 79.8443C83.4552 80.2041 83.3549 80.566 83.2437 80.9258C81.8657 85.3868 76.2316 86.8979 72.8999 83.6316C68.2186 79.0419 63.6049 74.3803 58.9673 69.7469C57.864 68.6437 57.3145 67.2875 57.1227 65.7503C57.0769 65.3862 56.8981 64.9675 56.643 64.7102C54.794 62.8329 52.9101 60.9905 51.1113 59.2091C53.2176 57.0636 55.2453 55.001 57.3189 52.8882C59.0436 54.6194 60.8533 56.4182 62.6412 58.2432C63.0598 58.6706 63.4763 58.9017 64.1086 58.9453C65.624 59.05 66.9235 59.7346 67.9962 60.8052C72.5576 65.3622 77.1059 69.9345 81.6673 74.4915C82.7073 75.5293 83.1914 76.8354 83.562 78.209V79.8443Z"
        fill="#F6A000"
      />
      <path
        d="M61.0051 32.5845C61.0225 49.4214 47.2882 63.1775 30.4796 63.1579C13.7059 63.1383 0.0130917 49.4193 9.38888e-06 32.6172C-0.0130729 15.7366 13.6471 2.03073 30.4884 2.02637C47.3602 2.02419 60.9876 15.6691 61.0051 32.5845ZM6.82026 32.6216C6.8486 45.7257 17.43 56.2984 30.5058 56.2897C43.6252 56.2809 54.211 45.6516 54.1783 32.5191C54.1477 19.4019 43.5859 8.85752 30.484 8.86624C17.3472 8.87496 6.79191 19.4716 6.81808 32.6216H6.82026Z"
        fill="#F6A000"
      />
      <path
        d="M19.2476 20.1565C20.6104 20.139 21.3146 21.2118 20.8655 22.2104C20.7565 22.4524 20.5711 22.6661 20.3902 22.8645C15.1681 28.5793 15.1747 36.5115 20.4098 42.2983C21.0944 43.0571 21.1991 43.7853 20.7129 44.4285C20.1372 45.1895 19.1452 45.2004 18.3777 44.422C16.0861 42.0933 14.5598 39.3264 13.9297 36.1256C12.7893 30.3367 14.224 25.2324 18.2316 20.8891C18.5608 20.5315 19.0318 20.3069 19.2455 20.1586L19.2476 20.1565Z"
        fill="#F6A000"
      />
    </svg>
  );
}

export { TargetTipsIcon };
